"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const WidgetRoi = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, x: 2, y: 2, fill: "#30BDC3", className: styles.accentColor, rx: 2 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        d: "M11.399 14.1h1.222v-1.344c1.106-.185 1.879-.911 1.879-2.03 0-1.037-.657-1.671-1.73-1.937l-1.199-.288c-.484-.127-.737-.346-.737-.738 0-.473.392-.784 1.003-.784.68 0 1.072.335 1.222.773h1.372c-.196-.946-.796-1.626-1.81-1.857V4.5h-1.223v1.35c-1.164.15-1.937.933-1.937 2.017 0 1.141.75 1.66 1.684 1.88l1.13.276c.6.138.841.357.841.784 0 .519-.415.819-1.072.819-.646 0-1.118-.265-1.314-.853H9.3c.196 1.106.968 1.798 2.098 1.983z"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { width: 14, height: 1, x: 5, y: 17, fill: "#fff", opacity: 0.6, rx: 0.5 }),
    /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M5 17.5a.5.5 0 0 1 .5-.5H10v1H5.5a.5.5 0 0 1-.5-.5" }),
    /* @__PURE__ */ React.createElement("circle", { cx: 9.5, cy: 17.5, r: 1.5, fill: "#fff" })
  );
};
export default WidgetRoi;
